import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss']
})
export class CustomHeaderComponent {

  // titulo principal del header
  @Input() titulo = 'Titulo de la pagina';

  // ruta de retorno del boton atrás
  @Input() btnAtras: string = null;
  @Input() btnAccionList: Array<any> = [];

  @Output() btnAccion: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
  ) {
  }


  backPage(): void {

    // esta accion va a estar en el padre del header
    this.router.navigate([this.btnAtras]);

  }

  action(btnKey: string): void {
    this.btnAccion.emit({ key: btnKey, obj: null});
  }

}
